export const ACTION_SELECT_FILTER = 'selectFilter';
